import { Feature, Point } from "geojson";
import { Layer, Source } from "react-map-gl";
import React, { ReactNode } from "react";

/* map slots are a way to consistently control layer ordering.
 *  these layers should be the first element in your extraLayers object so they are loaded before
 *  the other layers. Then you are able to specify these slot ids as beforeIds for your layers.
 */
export const useMapSlots = (slotIds: string[]): ReactNode => {
  const slotFeatures: Feature<Point, { slotId: string; index: number }>[] =
    slotIds.map((slotId, i) => ({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [0, 0], // these elements are barely visible and rendered at 0,0 so they shouldn't interact with your maps.
      },
      properties: { slotId, index: i },
    }));

  return slotFeatures
    .map((feature, i, allFeatures) => {
      return (
        <Source key={feature.properties.slotId} type="geojson" data={feature}>
          <Layer
            type="symbol"
            id={feature.properties.slotId}
            beforeId={
              allFeatures[i + 1]
                ? allFeatures[i + 1]?.properties.slotId
                : undefined
            }
            paint={{
              "text-opacity": 0.01, // if the layers are completely invisible, they are culled, and then the layers don't exist.
              "text-halo-width": 2,
              "text-color": "#FFF",
              "text-halo-color": "#000",
            }}
            layout={{
              "text-field": ["get", "slotId"],
              "text-offset": [feature.properties.index * 4, 0],
            }}
          />
        </Source>
      );
    })
    .toReversed();
};
